import _DividerButton from 'v2/components/UI/Buttons/components/DividerButton'
import _FilledButton from 'v2/components/UI/Buttons/components/FilledButton'

export const DividerButton = _DividerButton
export const FilledButton = _FilledButton
